import React from 'react';

/**
 * Helper function to render text with clickable email links
 * Automatically detects email addresses in text and converts them to mailto: links
 * 
 * @param {string} text - The text that may contain email addresses
 * @returns {Array} - Array of React elements (text and links)
 * 
 * @example
 * renderTextWithEmailLinks("Contact us at: info@example.com")
 * // Returns: ["Contact us at: ", <a href="mailto:info@example.com">info@example.com</a>]
 */
export const renderTextWithEmailLinks = (text) => {
  const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
  const parts = text.split(emailRegex);
  
  return parts.map((part, index) => {
    if (emailRegex.test(part)) {
      return (
        <a key={index} href={`mailto:${part}`} className="email-link">
          {part}
        </a>
      );
    }
    return part;
  });
};

